import { ComponentIds } from '@inter-ikea-core/core';
/**
 * @param {Entity} entity - an entity
 * @returns {WorldTransformComponent | null} the World Transform Component for the entity if it exists (or null)
 */
export const getWorldTransformComponent = (entity) => entity.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID) ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {Transform | null} the Transform for the World Transform Component for the entity if it exists (or null)
 */
export const getWorldTransform = (entity) => getWorldTransformComponent(entity)?.transform ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {Vector | null} the world position for the entity (or null)
 */
export const getWorldPosition = (entity) => getWorldTransform(entity)?.position ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {Quaternion | null} the world rotation for the entity (or null)
 */
export const getWorldRotation = (entity) => getWorldTransform(entity)?.rotation ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {Vector | null} the world rotation for the entity in Euler Degrees (or null)
 */
export const getWorldRotationInEulerDegrees = (entity) => getWorldRotation(entity)?.toEulerDegrees() ?? null;
//# sourceMappingURL=entity-transform-utils.js.map